import { render } from "./WriteBoard.vue?vue&type=template&id=a851b33e"
import script from "./WriteBoard.vue?vue&type=script&lang=js"
export * from "./WriteBoard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./WriteBoard.vue?vue&type=style&index=0&id=a851b33e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__